export const USER_BALANCE_FETCHED = 'USER_BALANCE_FETCHED';
export const USER_FETCH_DATA = 'USER_FETCH_DATA';
export const USER_CLEAR = 'USER_CLEAR';
